module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/confirmation-page-fail/confirmation-page-fail.component.scss
// module id = ./src/app/shared-components/confirmation-page-fail/confirmation-page-fail.component.scss
// module chunks = main